import React from 'react';

/**
 * Компонент боковой панели с полезными советами по ипотеке
 */
const TipsSidebar = () => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Полезные советы</h3>
      <ul className="space-y-3">
        {/* Совет о налоговом вычете */}
        <li className="p-3 bg-gradient-to-tr from-blue-50 to-cyan-50 dark:from-blue-900/30 dark:to-cyan-900/30 rounded-lg border border-blue-100 dark:border-blue-800/50">
          <h4 className="font-medium text-blue-700 dark:text-blue-300 mb-1 text-sm">Налоговый вычет</h4>
          <p className="text-xs text-blue-600 dark:text-blue-400">
            Верните до 650 000 ₽ (13% от 2 млн ₽ за покупку + 13% от 3 млн ₽ за %%).
          </p>
        </li>
        
        {/* Совет о досрочном погашении */}
        <li className="p-3 bg-gradient-to-tr from-green-50 to-lime-50 dark:from-green-900/30 dark:to-lime-900/30 rounded-lg border border-green-100 dark:border-green-800/50">
          <h4 className="font-medium text-green-700 dark:text-green-300 mb-1 text-sm">Досрочное погашение</h4>
          <p className="text-xs text-green-600 dark:text-green-400">
            Уменьшение срока чаще выгоднее для экономии на процентах.
          </p>
        </li>
        
        {/* Совет о рефинансировании */}
        <li className="p-3 bg-gradient-to-tr from-amber-50 to-orange-50 dark:from-amber-900/30 dark:to-orange-900/30 rounded-lg border border-amber-100 dark:border-amber-800/50">
          <h4 className="font-medium text-amber-700 dark:text-orange-300 mb-1 text-sm">Рефинансирование</h4>
          <p className="text-xs text-amber-600 dark:text-orange-400">
            Рассмотрите, если ставки упали на 1-2% и прошло не более трети срока.
          </p>
        </li>
        
        {/* Совет о маткапитале */}
        <li className="p-3 bg-gradient-to-tr from-purple-50 to-fuchsia-50 dark:from-purple-900/30 dark:to-fuchsia-900/30 rounded-lg border border-purple-100 dark:border-purple-800/50">
          <h4 className="font-medium text-purple-700 dark:text-fuchsia-300 mb-1 text-sm">Материнский капитал</h4>
          <p className="text-xs text-purple-600 dark:text-fuchsia-400">
            Можно использовать как часть первоначального взноса или погасить часть кредита.
          </p>
        </li>
        
        {/* Совет о страховании */}
        <li className="p-3 bg-gradient-to-tr from-indigo-50 to-violet-50 dark:from-indigo-900/30 dark:to-violet-900/30 rounded-lg border border-indigo-100 dark:border-indigo-800/50">
          <h4 className="font-medium text-indigo-700 dark:text-violet-300 mb-1 text-sm">Экономия на страховке</h4>
          <p className="text-xs text-indigo-600 dark:text-violet-400">
            Сравнивайте предложения разных страховых компаний, а не только предложенные банком.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default TipsSidebar;